"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableConstants = _interopRequireDefault(require("./TableConstants"));

var _TableUtils = require("./TableUtils");

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _TableRowSelection = _interopRequireDefault(require("./TableRowSelection"));

var _CheckMarkIcon = _interopRequireDefault(require("../Icons/CheckMarkIcon"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ChevronDownIcon = _interopRequireDefault(require("../Icons/ChevronDownIcon"));

var _ChevronUpIcon = _interopRequireDefault(require("../Icons/ChevronUpIcon"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Menu = _interopRequireDefault(require("../Navigation/Menu"));

var _MenuItem = _interopRequireDefault(require("../Navigation/MenuItem"));

var _TripleDotVerticalIcon = _interopRequireDefault(require("../Icons/TripleDotVerticalIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Row inside Table
 */
var TableRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableRow, _React$Component);

  function TableRow() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TableRow)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.renderRowSelection = function () {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          eventHandlers = _this$props.eventHandlers,
          rowIndex = _this$props.rowIndex,
          rowKey = _this$props.rowKey,
          rowSelection = _this$props.rowSelection;
      var selected = rowSelection.selected;
      var isSelected = selected && selected.indexOf(rowData[rowKey]) > -1;
      return _react.default.createElement(_TableRowSelection.default, {
        eventHandlers: eventHandlers,
        isSelected: isSelected,
        rowIndex: rowIndex,
        rowKeyVal: rowData[rowKey],
        type: rowSelection.type
      });
    }, _this.renderRowAction = function () {
      var _this$props2 = _this.props,
          editRow = _this$props2.editRow,
          rowAction = _this$props2.rowAction,
          rowData = _this$props2.rowData,
          rowIndex = _this$props2.rowIndex; // If the row is in edit mode, don't allow user to do any other action
      // Thats just asking for trouble

      if (editRow && editRow.row) {
        return null;
      }

      var actionIcon = _react.default.createElement(_Button.default, {
        className: "row-action-icon",
        type: "borderless",
        appearance: "mini"
      }, _react.default.createElement(_TripleDotVerticalIcon.default, null));

      var actions;

      if ((0, _isFunction2.default)(rowAction.actions)) {
        actions = rowAction.actions(rowData, rowIndex);
      } else {
        actions = rowAction.actions || [];
      }

      var menuItems = [];

      for (var i = 0; i < actions.length; i++) {
        menuItems.push(_react.default.createElement(_MenuItem.default, {
          key: actions[i].key
        }, actions[i].value));
      }

      var menu = _react.default.createElement(_Menu.default, {
        appearance: _Menu.default.APPEARANCE.COMPACT,
        onClick: _this.handleClickRowAction
      }, menuItems);

      var dropdownTableOffset = '-10px';
      var dropDown = rowAction.getPopupContainer ? _react.default.createElement(_Dropdown.default, {
        getPopupContainer: rowAction.getPopupContainer,
        popup: menu,
        popupPlacement: "leftTop",
        popupOffset: {
          y: dropdownTableOffset
        }
      }, actionIcon) : _react.default.createElement(_Dropdown.default, {
        popup: menu,
        popupPlacement: "leftTop",
        popupOffset: {
          y: dropdownTableOffset
        }
      }, actionIcon);
      return _react.default.createElement(_FlexLayout.default, {
        alignItems: "center",
        justifyContent: "center"
      }, dropDown);
    }, _this.handleClickRowAction = function (info) {
      var _this$props3 = _this.props,
          rowData = _this$props3.rowData,
          rowIndex = _this$props3.rowIndex;

      _this.props.rowAction.onRowAction(info.key, rowData, rowIndex);
    }, _this.renderRowExpand = function () {
      var _this$props4 = _this.props,
          editRow = _this$props4.editRow,
          rowData = _this$props4.rowData,
          rowKey = _this$props4.rowKey;
      var rowKeyVal = rowData[rowKey]; // If the row is in edit mode, don't render the row expand cell content

      if (editRow && editRow.row === rowKeyVal) {
        return null;
      }

      var expandedIcon = _react.default.createElement(_ChevronDownIcon.default, null);

      if (_this.isRowExpanded()) {
        expandedIcon = _react.default.createElement(_ChevronUpIcon.default, null);
      }

      return _react.default.createElement(_FlexLayout.default, {
        className: "row-expand-icon",
        alignItems: "center",
        justifyContent: "center",
        onClick: _this.handleClickRowExpand
      }, expandedIcon);
    }, _this.handleClickRowExpand = function () {
      var _this$props5 = _this.props,
          rowData = _this$props5.rowData,
          eventHandlers = _this$props5.eventHandlers,
          rowKey = _this$props5.rowKey;
      eventHandlers.handleRowExpandChange(rowData[rowKey]);
    }, _this.renderEditRow = function () {
      var _this$props6 = _this.props,
          editRow = _this$props6.editRow,
          eventHandlers = _this$props6.eventHandlers;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('edit-row-btns', '-focus', editRow && editRow.overflow ? 'overflow' : '')
      }, _react.default.createElement(_Button.default, {
        appearance: "mini",
        type: "secondary",
        className: "edit-row-btn",
        onClick: function onClick() {
          return eventHandlers.handleEditRowCancelClick();
        }
      }, _react.default.createElement(_CloseIcon.default, {
        size: "small"
      })), _react.default.createElement(_Button.default, {
        appearance: "mini",
        type: "primary",
        className: "edit-row-btn",
        onClick: function onClick() {
          return eventHandlers.handleEditRowSubmitClick();
        }
      }, _react.default.createElement(_CheckMarkIcon.default, {
        size: "small"
      })));
    }, _temp));
  }

  _createClass(TableRow, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          className = _this$props7.className,
          columnKey = _this$props7.columnKey,
          columns = _this$props7.columns,
          customProps = _this$props7.customProps,
          editRow = _this$props7.editRow,
          rowData = _this$props7.rowData,
          rowAction = _this$props7.rowAction,
          rowExpand = _this$props7.rowExpand,
          rowIndex = _this$props7.rowIndex,
          rowKey = _this$props7.rowKey,
          rowSelection = _this$props7.rowSelection;
      var rowCells = [];
      var rowAlert = this.getRowAlert();

      if (rowSelection) {
        var selectionColumn = {};
        selectionColumn.className = 'selection-column';
        selectionColumn[columnKey] = 'selectionColumn';
        selectionColumn.render = this.renderRowSelection;
        rowCells.push(this.renderTableCell(selectionColumn));
      } // If there are column groups defined, we should flatten the columns prop
      // so we can process the column definitions inside group


      var flattenedColumns = (0, _TableUtils.flattenResizableColumns)(columns);

      for (var i = 0; i < flattenedColumns.length; i++) {
        var column = flattenedColumns[i];

        if (rowAlert && i === 0) {
          // The first data cell should render the row alert icon
          rowCells.push(this.renderTableCell(column, rowAlert));
        } else {
          rowCells.push(this.renderTableCell(column));
        }
      }

      if (rowAction) {
        var rowActionColumn = {};
        rowActionColumn.className = 'row-action';
        rowActionColumn[columnKey] = 'rowAction';
        rowActionColumn.render = this.renderRowAction;
        rowCells.push(this.renderTableCell(rowActionColumn));
      }

      var hasExpandedRow = false;

      if (rowExpand) {
        hasExpandedRow = rowExpand.render && rowExpand.render(rowData, rowIndex);
        var rowExpandColumn = {};
        rowExpandColumn.className = 'row-expand';
        rowExpandColumn[columnKey] = 'rowExpand';

        if (hasExpandedRow) {
          rowExpandColumn.render = this.renderRowExpand;
        }

        rowCells.push(this.renderTableCell(rowExpandColumn));
      }

      var hasFocus = false;

      if (editRow) {
        var editRowColumn = {};
        editRowColumn.className = 'edit-row';
        editRowColumn[columnKey] = 'editRow';

        if (editRow.row === rowData[rowKey]) {
          editRowColumn.render = this.renderEditRow;
          hasFocus = true;
        } // If row has focus, add the edit-row cell


        rowCells.push(this.renderTableCell(editRowColumn));
      }

      var focusClass = hasFocus ? '-focus' : '';
      var rowProps = customProps && customProps.rowProps;
      var trProps = rowProps ? rowProps(rowData, rowIndex) : {};
      var hasRowWarning = rowAlert && rowAlert.type === _TableConstants.default.TABLE_ALERT.WARNING;
      var hasRowError = rowAlert && rowAlert.type === _TableConstants.default.TABLE_ALERT.ERROR;
      return _react.default.createElement("tr", _extends({
        className: (0, _classnames.default)(className, focusClass, hasExpandedRow ? 'has-expanded-row' : '', this.isRowExpanded() ? 'row-expanded' : '', hasRowWarning ? 'has-row-warning' : '', hasRowError ? 'has-row-error' : '')
      }, trProps), rowCells);
    }
    /**
     * Render table cell
     * @param {Object} column - Column data
     * @param {Object} rowAlert - Row alert to be rendered
     * @returns {ReactElement} - Table cell element
     */

  }, {
    key: "renderTableCell",
    value: function renderTableCell(column, rowAlert) {
      var _this$props8 = this.props,
          cellAlerts = _this$props8.cellAlerts,
          columnKey = _this$props8.columnKey,
          customProps = _this$props8.customProps,
          editDirect = _this$props8.editDirect,
          editRow = _this$props8.editRow,
          eventHandlers = _this$props8.eventHandlers,
          rowData = _this$props8.rowData,
          rowIndex = _this$props8.rowIndex,
          rowKey = _this$props8.rowKey;
      return _react.default.createElement(_TableCell.default, {
        key: "cell-".concat(rowData[rowKey], "-").concat(column[columnKey]),
        cellAlerts: cellAlerts,
        columnKey: columnKey,
        column: column,
        customProps: customProps,
        editDirect: editDirect,
        editRow: editRow,
        eventHandlers: eventHandlers,
        rowAlert: rowAlert,
        rowData: rowData,
        rowIndex: rowIndex,
        rowKey: rowKey
      });
    }
    /**
     * Custom render for selection
     * @returns {object} - jsx for selection
     */

  }, {
    key: "isRowExpanded",

    /**
     * Returns whether or not this row is currently expanded
     * @returns {boolean} - Is this row currently expanded?
     */
    value: function isRowExpanded() {
      var _this$props9 = this.props,
          rowData = _this$props9.rowData,
          rowExpand = _this$props9.rowExpand,
          rowKey = _this$props9.rowKey;
      var rowKeyVal = rowData[rowKey];
      return rowExpand && rowExpand.rows && rowExpand.rows.indexOf(rowKeyVal) >= 0;
    }
    /**
     * Get row alert config object for this row
     * @returns {object|null} - Row alert object or null
     */

  }, {
    key: "getRowAlert",
    value: function getRowAlert() {
      var _this$props10 = this.props,
          rowData = _this$props10.rowData,
          rowKey = _this$props10.rowKey;
      var rowAlerts = this.props.rowAlerts || [];
      var rowAlert = null;

      for (var i = 0; i < rowAlerts.length; i++) {
        if (rowAlerts[i].row === rowData[rowKey]) {
          rowAlert = rowAlerts[i];
          break;
        }
      }

      return rowAlert;
    }
  }]);

  return TableRow;
}(_react.default.Component);

exports.default = TableRow;
TableRow.propTypes = {
  /**
   * Additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Array of cell alert configs
   */
  cellAlerts: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Unique key for a row.
   */
  columnKey: _propTypes.default.string,

  /**
   * Array of column objects
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Custom props to pass into table elements
   */
  customProps: _propTypes.default.object,

  /**
   * Object with direct edit config
   */
  editDirect: _propTypes.default.object,

  /**
   * Object with edit row config
   */
  editRow: _propTypes.default.object,

  /**
   * Table event handlers
   */
  eventHandlers: _propTypes.default.object,

  /**
   * Object to use as the data source for the table row.
   */
  rowData: _propTypes.default.object.isRequired,

  /**
   * Object with row action options
   */
  rowAction: _propTypes.default.object,

  /**
   * Array of row alert configs
   */
  rowAlerts: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object with row expand options
   */
  rowExpand: _propTypes.default.object,

  /**
   * Index of row from data source
   */
  rowIndex: _propTypes.default.number,

  /**
   * Unique key for a row.
   */
  rowKey: _propTypes.default.string,

  /**
   * Object with row selection options
   */
  rowSelection: _propTypes.default.object
};